// ✅ redux/states/products/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL PRODUCT -------------------- */
export const AllProductsThunk = createAsyncThunk(
  "products/AllProductsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/products/list`); // ✅ GET request for product list
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch products"
      );
    }
  }
);

/* -------------------- GET SINGLE PRODUCT -------------------- */
export const GetSingleProductThunk = createAsyncThunk(
  "products/getSingle",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/products/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch product details"
      );
    }
  }
);

/* -------------------- ADD PRODUCT -------------------- */
export const AddProductThunk = createAsyncThunk(
  "products/add",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/products/add`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add product");
    }
  }
);

/* -------------------- UPDATE PRODUCT -------------------- */
export const UpdateProductThunk = createAsyncThunk(
  "products/update",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/products/update?uuid=${uuid}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update product"
      );
    }
  }
);

/* -------------------- DELETE PRODUCT -------------------- */
export const DeleteProductThunk = createAsyncThunk(
  "products/delete",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/products/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete product"
      );
    }
  }
);

/* -------------------- ALL PRODUCT category -------------------- */
/* -------------------- ALL PRODUCT category -------------------- */

/* -------------------- ALL Category -------------------- */
export const AllProductsCategoryThunk = createAsyncThunk(
  "products/AllProductsCategoryThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/categories/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch categories"
      );
    }
  }
);

/* -------------------- ALL Sub Category (by category slug) -------------------- */
export const AllProductsSubCategoryThunk = createAsyncThunk(
  "products/AllProductsSubCategoryThunk",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/subcategory/filter/${slug}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch subcategories"
      );
    }
  }
);

/* -------------------- ALL PRODUCT gallery -------------------- */
/* -------------------- ALL PRODUCT gallery -------------------- */

/* -------------------- ALL GALLERY IMAGES -------------------- */
export const AllProductGalleryImageThunk = createAsyncThunk(
  "gallery/all",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/product-images/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch gallery images"
      );
    }
  }
);

/* -------------------- GET SINGLE GALLERY IMAGE -------------------- */
export const GetSingleProductGalleryImageThunk = createAsyncThunk(
  "gallery/getSingle",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/product_images/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch image details"
      );
    }
  }
);

/* -------------------- ADD GALLERY IMAGE -------------------- */
export const AddProductGalleryImageThunk = createAsyncThunk(
  "gallery/add",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/product-images/add`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add image");
    }
  }
);

/* -------------------- UPDATE GALLERY IMAGE -------------------- */
export const UpdateProductGalleryImageThunk = createAsyncThunk(
  "gallery/update",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/product_images/update`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update image");
    }
  }
);

/* -------------------- DELETE GALLERY IMAGE -------------------- */
export const DeleteGalleryProductThunk = createAsyncThunk(
  "gallery/delete",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/product-images/delete?uuid=${uuid}&permanent=1`
      );
      return { uuid, message: response.data?.message };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete image");
    }
  }
);

/* -------------------- GET SINGLE PRODUCT -------------------- */
export const GetVarientlistThunk = createAsyncThunk(
  "products/GetVarientlistThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/public/valiants`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch product details"
      );
    }
  }
);

/* -------------------- ALL special categoyr -------------------- */
export const AllSpecialcategoryThunk = createAsyncThunk(
  "products/AllSpecialcategoryThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/products/special-category-list`); // ✅ GET request for product list
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch products"
      );
    }
  }
);

/* -------------------- mark special -------------------- */
export const MarkspecialThunk = createAsyncThunk(
  "products/MarkspecialThunk",
  async ({ uuid, special_category_id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/products/mark-special?uuid=${uuid}&special_category_id=${special_category_id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to mark special category"
      );
    }
  }
);
